import { SetStateAction, useMemo, useState } from 'react'

import debounce from 'debounce'
import { Select } from 'flowbite-react'
import { useParams } from 'react-router-dom'

import Loader from '@/components/Loader'
import TableItem from '@/components/Table'
import PaginationItem from '@/components/Table/pagination-item'
import SearchTableItem from '@/components/Table/search'
import { useGetLancamentos } from '@/hooks/queries/use-get-pedidos'
import { TABLE_HEADERS_LANCAMENTOS_PEDIDO } from '@/pages/Pedidos/constants'
import { formatCurrency } from '@/utils'

const DetailCobrancasPedido = () => {
  const { id } = useParams()
  const [search, setSearch] = useState('')
  const [pageSize, setPageSize] = useState(10)
  const [lancamentosPage, setLancamentosPage] = useState<number>(1)
  const lancamentosInicio = (lancamentosPage - 1) * pageSize
  const { data: lancamentosList, isIdle, isLoading: isLancamentosLoading } = useGetLancamentos({
    params: {
      pedidoId: id,
      procurar: search,
      inicio: lancamentosInicio,
      comprimento: pageSize,
      tipoLancamentoFinanceiro: 1
    }
  })
  const lancamentosTotalPages = Math.ceil(
    (lancamentosList?.conteudo?.quantidadeDeItems ?? 0) / pageSize
  )
  const handleSearch = debounce((e: SetStateAction<string>) => {
    setSearch(e)
  }, 500)

  const mapedlancamentos = useMemo(() => {
    return lancamentosList?.conteudo?.resultados.map(item => {
      return {
        descricao: item.descricao,
        valor: formatCurrency(item.valor)
      }
    })
  }, [lancamentosList])

  const valorTotal = lancamentosList?.conteudo?.total?.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL'
  })
  return (
    <div className='overflow-x-auto'>
      <SearchTableItem
        isAddItem={false}
        isSearchInputEnabled={true}
        setFilterText={e => handleSearch(e)}
      />
      {isLancamentosLoading ? (
        <div
          className='h-96 w-full flex justify-center items-center'
          data-testid='loader-lancamentos-cobrancas'
        >
          <Loader size={'xl'} />
        </div>
      ) : (
        <TableItem
          isActions={false}
          isRowClicable={false}
          data={mapedlancamentos || []}
          headers={TABLE_HEADERS_LANCAMENTOS_PEDIDO}
          deleteAction={() => void 0}
          hasCustomActions={false}
          idKey='pedidoId'
          isIdle={isIdle}
        />
      )}
      <PaginationItem
        totalItems={
          lancamentosList?.conteudo?.quantidadeDeItems ?? (0 as number)
        }
        totalPages={lancamentosTotalPages}
        pageSize={pageSize}
        onPageChange={(pageParam: number) => setLancamentosPage(pageParam)}
        forceDisplay={true}
      >
        <Select
          id='select-page-size'
          data-testid='select-page-size'
          onChange={e => setPageSize(Number(e.target.value))}
        >
          <option value='10'>10</option>
          <option value='25'>25</option>
          <option value='50'>50</option>
          <option value='100'>100</option>
        </Select>
      </PaginationItem>
      {!!lancamentosList?.conteudo?.resultados?.length && (
        <div className='w-full pt-5 flex items-center justify-end'>
           <span className='font-bold text-xl' data-testid='total-value-text'>
            Valor total geral:{' '}
            <span className='text-quaternary'>{valorTotal}</span>
          </span>
        </div>
      )}
    </div>
  )
}

export default DetailCobrancasPedido
